
import { VDPopupListboxClass } from "@/components/pickers/VDPopupListbox";
import VDPopupListbox from "@/components/pickers/VDPopupListbox.vue";
import { RoleType, ApplicationType } from "@/graphql/types";
import GroupedItems from "@/models/GroupedItems";
import { defineComponent, PropType, ref, computed } from "vue";

export default defineComponent({
  components: {
    VDPopupListbox,
  },
  emits: ["addedRole"],
  props: {
    addedRoles: {
      type: Array as PropType<RoleType[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    application: {
      type: Object as PropType<ApplicationType>,
      default: () => ({}),
    },
  },
  setup(props) {
    // VDOM
    const listbox = ref<VDPopupListboxClass>();
    // Refs
    const isEnabled = ref(false);

    const groupedRoles = computed(() => {
      // Handle cases where application or roles might be undefined
      if (
        !props.application ||
        !props.application.roles ||
        props.application.roles.length === 0
      ) {
        return [];
      }

      const result = [
        {
          name: props.application.name || "Application",
          items: props.application.roles,
        },
      ];

      return result;
    });

    const hasRoles = computed(() => {
      return props.application?.roles && props.application.roles.length > 0;
    });

    const isLoading = computed(() => {
      // Return true if application is undefined (still loading)
      return !props.application;
    });

    return {
      groupedRoles,
      hasRoles,
      isLoading,
      listbox,
      toggle: (event: Event) => {
        isEnabled.value = true;
        listbox.value?.toggle(event);
      },
    };
  },
});
